import { getWorkCommonCode } from '@/api/code';
import { getCodeNm, getCodeObj } from '@/utils/common/codeUtil';

const codeStore = {
  namespaced: 'CODE',
  state: {
    gntCd: [],
    gntGubunCdList: [],

    gntCodeTmp: '',
    gntGubunTmp: '',
  },
  getters: {
    GET_GNT_CD_LIST(state) {
      return state.gntCd;
    },
    GET_GNT_CD_OBJ(state) {
      return getCodeObj(state.gntCd, state.gntCodeTmp);
    },
    GET_GNT_CD_NM(state) {
      return getCodeNm(state.gntCd, state.gntCodeTmp);
    },
    GET_GNT_GUBUN_NM(state) {
      return getCodeNm(state.gntGubunCdList, state.gntGubunTmp);
    },
    GET_GNT_GUBUN_OBJ(state) {
      return getCodeObj(state.gntGubunCdList, state.gntGubunTmp);
    },
  },
  mutations: {
    SET_GNT_CD_EMPTY(state) {
      state.gntCd = [];
    },
    SET_GNT_CD_LIST(state, data) {
      state.gntCd = data;
    },
    SET_GNT_CODE_TMP(state, data) {
      state.gntCodeTmp = data;
    },
    SET_GNT_GUBUN_CD_LIST(state, data) {
      state.gntGubunCdList = data;
    },
    SET_GNT_GUBUN_TMP(state, data) {
      state.gntGubunTmp = data;
    },
    RESET_CODE_STATE(state) {
      state.gntCd = [];
      state.gntGubunCdList = [];
      state.gntCodeTmp = '';
      state.gntGubunTmp = '';
    },
  },
  actions: {
    async FETCH_GNT_CD({ commit }, param) {
      const response = await getWorkCommonCode(param);
      commit('SET_GNT_CD_LIST', response.data.data);
      return response.data.data.length;
    },
    GET_GNT_CD_NM({ state }, code) {
      return getCodeNm(state.gntCd, code);
    },

    async FETCH_GNT_GUBUN_CD_LIST({ commit }) {
      const response = await getWorkCommonCode({
        cmd: 'gntGubunCdApp',
      });
      commit('SET_GNT_GUBUN_CD_LIST', response.data.data);
    },
  },
};

export default codeStore;
